import { render } from "./WithdrawConfirmModal.vue?vue&type=template&id=3c387a4a&scoped=true"
import script from "./WithdrawConfirmModal.vue?vue&type=script&lang=js"
export * from "./WithdrawConfirmModal.vue?vue&type=script&lang=js"

import "./WithdrawConfirmModal.vue?vue&type=style&index=0&id=3c387a4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c387a4a"]])

export default __exports__